import React, { PureComponent } from 'react';
import { arrayOf, bool, func, number, object, objectOf } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as sliderActions from '../../actions/SliderActions';
import { SelectedFacets } from '../SelectedFacets/SelectedFacets';
import { promotedFilterChange } from '../../actions/AnalyticsActions';
import { updateUrl } from '../../utils';

export class SuggestedFilters extends PureComponent {
    static defaultProps = {
        actions: {},
        deviceType: {},
        enableSuggestedFilters: true,
        irisDataRowContent: [],
        isSuggestedFiltersPriority: false,
        suggestedFacetList: [
            {
                suggestedFacetName: '',
                suggestedFacetValueList: [],
            },
        ],
        suggestedFilterLimit: 10,
    };

    static propTypes = {
        actions: objectOf(func),
        deviceType: objectOf(bool),
        enableSuggestedFilters: bool,
        irisDataRowContent: arrayOf(object),
        isSuggestedFiltersPriority: bool,
        suggestedFacetList: arrayOf(object),
        suggestedFilterLimit: number,
    };

    handleClick = (event, apiUrl, heading) => {
        promotedFilterChange({ value: 'suggestedfilter', heading });
        updateUrl(apiUrl, null, null, null);
    };

    showSeeMoreButton = () => {
        const { suggestedFacetList, suggestedFilterLimit } = this.props;

        return suggestedFacetList[0].suggestedFacetValueList.length > suggestedFilterLimit;
    };

    renderActivePills = () => {
        const { suggestedFilterLimit, suggestedFacetList } = this.props;

        return suggestedFacetList[0].suggestedFacetValueList
            .slice(0, suggestedFilterLimit)
            .map(({ apiUrl, name }) => (
                <li key={name}>
                    <button
                        className="px-4 py-1 mr-2 bg-gray-100 capitalize rounded-medium whitespace-no-wrap"
                        onClick={(event) => this.handleClick(event, apiUrl, name)}
                        type="button"
                    >
                        {name}
                    </button>
                </li>
            ));
    };

    render() {
        const {
            actions: { toggleSlider },
            deviceType: { isMobile },
            enableSuggestedFilters,
            irisDataRowContent,
            isSuggestedFiltersPriority,
            suggestedFacetList,
        } = this.props;

        const hasSuggestedFilters =
            suggestedFacetList.length &&
            suggestedFacetList[0].suggestedFacetValueList.length &&
            enableSuggestedFilters;

        // Determine if there are any visual nav items in the page.
        const hasIrisVisualNav = () => {
            const irisComponents = irisDataRowContent.reduce(
                (acc, data) =>
                    data &&
                    data.columns &&
                    data.columns[0] &&
                    data.columns[0].components &&
                    data.columns[0].components.length
                        ? acc.concat(data.columns[0].components)
                        : [],
                []
            );

            return (
                irisComponents.findIndex((element) => element.componentType === 'visualnav') >= 0
            );
        };

        const shouldDisplaySuggestedFilters =
            !hasIrisVisualNav() || (hasIrisVisualNav() && isSuggestedFiltersPriority);

        const shouldRender = hasSuggestedFilters && shouldDisplaySuggestedFilters;

        if (shouldRender) {
            const SeeMoreButton = () => (
                <li>
                    <button
                        className="px-4 py-1 mr-2 bg-gray-100 capitalize rounded-medium whitespace-no-wrap"
                        onClick={toggleSlider}
                        type="button"
                    >
                        See More
                    </button>
                </li>
            );

            const Title = ({ buttonText }) => (
                <h3 className="text-gray-600 font-open-sans-semibold text-small mb-1">
                    {buttonText}
                    <span className="capitalize">{suggestedFacetList[0].suggestedFacetName}</span>
                </h3>
            );

            return (
                <div data-automation-id="suggested-filters" className="SuggestedFilters text-small">
                    <Title buttonText="Narrow by&nbsp;" />
                    <ul className="flex overflow-x-auto text-gray-600">
                        {this.renderActivePills()}
                        {isMobile && this.showSeeMoreButton() && <SeeMoreButton />}
                    </ul>
                    {isMobile && (
                        <SelectedFacets
                            clearAllWrapperClass="flex justify-end w-full"
                            showResultsCount={false}
                            showTitle={false}
                            wrapperClass="px-0 my-2"
                        />
                    )}
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = (store) => ({
    deviceType: store.context && store.context.deviceType,
    enableSuggestedFilters: store.context.featureFlags.enableSuggestedFilters,
    irisDataRowContent: store.irisData && store.irisData.content && store.irisData.content.rows,
    isSuggestedFiltersPriority: store.context.featureFlags.isSuggestedFiltersPriority,
    suggestedFacetList: store.suggestedFilters.suggestedFacetList,
    suggestedFilterLimit: store.context.preferences.suggestedFilterLimit,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...sliderActions, promotedFilterChange }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedFilters);
